
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trends/[trend]",
      function () {
        return require("private-next-pages/trends/[trend].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trends/[trend]"])
      });
    }
  